import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy,
  Output, PLATFORM_ID, Renderer2, ViewChild, inject
} from '@angular/core';

// Portaled to document.body the same way GameWalletPanelComponent's modals are - an ancestor with
// backdrop-filter/transform/filter creates a new containing block for `position: fixed`, which
// broke naive full-viewport centering earlier this session. Same fix applies here.
@Component({
  selector: 'app-devtools-guard-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './devtools-guard-modal.component.html',
  styleUrl: './devtools-guard-modal.component.scss'
})
export class DevToolsGuardModalComponent implements AfterViewInit, OnDestroy {
  @Input() visible = false;
  @Input() reason = 'Unusual activity detected on your account during an active game. Your round has been ended.';
  @Output() dismissed = new EventEmitter<void>();

  @ViewChild('modalRoot') private modalRootRef!: ElementRef<HTMLElement>;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.renderer.appendChild(document.body, this.modalRootRef.nativeElement);
  }

  ngOnDestroy(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.modalRootRef?.nativeElement?.remove();
  }

  close(): void {
    this.dismissed.emit();
  }
}
